export default __webpack_public_path__ + "static/media/engage-phone-banner.444b27f8.png";